import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PolicyHistoryComponent } from './policy-history.component';
import { SharedModule } from '../../../shared/shared.module';
import { CustomPipesModule } from 'app/shared/custom pipes/custom-pipe.module';

const routes: Routes = [
  { path: '', component: PolicyHistoryComponent }
];

@NgModule({
  declarations: [PolicyHistoryComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    CustomPipesModule
  ],
  exports: [PolicyHistoryComponent]
})
export class PolicyHistoryModule { }
